module.exports = __webpack_public_path__ + "img/Group3.d2179eae.svg";